/**
 * Sales view mode — determines which validation rules apply and how application state is computed.
 * Standard = regular deal submission flow; Showroom (traditional) = showroom-specific flow with different validation and states.
 *
 * Shared between the BFF and the client, so it lives in shared-types.
 */
export enum SalesViewMode {
    Standard = 'standard',
    Showroom = 'traditional',
    SalesIntake = 'sales_intake'
}
